import React, { useEffect, useMemo, useState } from "react";
import { Alert, Button, Card, InputFecha, InputSelect, InputTexto, Title } from "../components";
import "../css/pages/RecaudacionPago.css"
import { ErrorValidations, FormatRutValidator, RequiredValidator, RutValidator } from "../enums-lists/Validations";
import { EntidadRecaudadora } from "../enums-lists/EntidadRecaudadora";
import { RecaudacionPagoState, UserState, GroupedPaymentType, InputSelectElement } from "../types-interfaces/interfaces";
import { GroupedPaymentModel, PaymentModel, PaymentModelDetail } from "../types-interfaces/types";
import { LuDownload } from "react-icons/lu";
import { getApiDateFormat, getDateFromTimestamp, moneyFormat } from "../functions/Format";
import { RootState } from "../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { setAlert, setBooleanValue, setDetalleNoRecaudado, setInitialState, setNumberValue, setResumeBox, setStringValue, setPaymentsIds } from "../redux/slices/pages/RecaudacionPagoSlice";
import * as XLSX from 'xlsx';
import { getPaymentList, paymentUpdateStatus } from "../services/api-ssrr/CollectionManagerAPIClient";
import { filterGroupedPayment, splitValue } from "../functions/Data";
import { SummaryAmountStyle, SummaryTableStyle } from "../components/styles/SummaryStyle";
import { PrimaryButtonStyle, SecondaryButtonStyle } from "../components/styles/ButtonStyle";
import { DetalleNoConfirmadoStyle } from "../components/styles/AlertStyle";
import { useAppDispatch } from "../redux/hooks";
import { fetchPaymentTypes, selectPaymentTypes } from "../redux/slices/paymentType/PaymentTypeSlice";
import { MRT_RowSelectionState, MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { columnsGroupedPaymentsCollection, columnsGroupedPaymentsDetail } from "../enums-lists/TableColumns";
import { cloneDeep } from 'lodash';
import { fetchPaymentUsers, selectPaymentUsers } from "../redux/slices/paymentUser/PaymentUserSlice";
import Modal from "../components/modal/Modal";
import ModalConfirm from "../components/modal/ModalConfirm";

interface RecaudacionPagoProps extends React.HTMLAttributes<HTMLElement>{
  className: string | undefined
}

const fechaCiclo = new Date();  //TODO: arreglar fecha ciclo

function RecaudacionPago(props:RecaudacionPagoProps) {    
  const [rowSelectionPayments, setRowSelectionPayments] = useState<MRT_RowSelectionState>({});
  const [rowSelectionPaymentsDetails, setRowSelectionPaymentsDetails] = useState<Array<MRT_RowSelectionState>>([]);
  const [tableData, setTableData] = useState<Array<GroupedPaymentModel>>([]);
  const [filteredTableData, setFilteredTableData] = useState<Array<GroupedPaymentModel>>([]);
  const [selectedTableData, setSelectedTableData] = useState<Array<PaymentModelDetail>>([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [paymentTypes, setPaymentTypes] = useState<Array<GroupedPaymentType>>([{ value: -1, name: 'Cargando...'}]);
  const [paymentUsers, setPaymentUsers] = useState<Array<InputSelectElement>>([{ value: '', name: 'Cargando...'}]);  
  const recaudacionPagoState = useSelector<RootState, RecaudacionPagoState>((state) => state.recaudacionPago);
  const userState = useSelector<RootState, UserState>((state) => state.userState);
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [isLoadingTable, setIsLoadingTable] = React.useState(false);
  const dispatch = useDispatch();

  const _dispatch = useAppDispatch();

  useEffect(() => {
    _dispatch(fetchPaymentTypes(userState, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_dispatch]);

  const paymentTypesFromAPI = useSelector<RootState, {loading: boolean, paymentTypes: Array<GroupedPaymentType>, error?: boolean}>(selectPaymentTypes);

  useEffect(() => {    
    setPaymentTypes(paymentTypesFromAPI.paymentTypes);    
  }, [paymentTypesFromAPI]);

  useEffect(() => {
    _dispatch(fetchPaymentUsers(userState, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_dispatch]);

  const paymentUsersFromAPI = useSelector<RootState, {loading: boolean, paymentUsers: Array<InputSelectElement>, error?: any}>(selectPaymentUsers);

  useEffect(() => {
    setPaymentUsers(paymentUsersFromAPI.paymentUsers);
  }, [paymentUsersFromAPI]);

  useEffect(() => {
    if (rowSelectionPaymentsDetails.length === 0 || rowSelectionPaymentsDetails.length !== tableData.length){
      let newRowState:MRT_RowSelectionState[] = [];
      tableData.forEach(()=>newRowState.push({}));
      setRowSelectionPaymentsDetails(newRowState);
      setRowSelectionPayments({});
      setFilteredTableData(tableData);      
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);

  useEffect(() => {
    let selectedData = cloneDeep(selectedTableData);
    let paymentsSelectedQuantity = 0;
    let clpTotalAmount = 0;
    let usdTotalAmount = 0;

    selectedData.forEach(row=> {
      paymentsSelectedQuantity++;
      clpTotalAmount += (row.currencyType === "CLP") ? row.amount : 0;
      usdTotalAmount += (row.currencyType === "USD") ? row.amount : 0;
    });

    dispatch(setResumeBox({
      paymentsQuantity: paymentsSelectedQuantity,
      pagosCLP: clpTotalAmount,
      pagosUSD: usdTotalAmount
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTableData]);

  useEffect(() => {    
    let copyTableData = cloneDeep(tableData);
    let copyFilterText = cloneDeep(globalFilter);
    let copySelectedTableData = cloneDeep(selectedTableData);

    let newFilteredTableData = filterGroupedPayment(copyTableData, copyFilterText);
    let newSelectedRows:MRT_RowSelectionState = {};
    let newSelectedRowsDetail:Array<MRT_RowSelectionState> = [];

    newFilteredTableData.forEach((row, rowIndex) => {      
      let isSelectedCount = 0;
      (newSelectedRowsDetail[rowIndex] as Record<string, boolean>) = {};
      row.detail.forEach((det, detIndex) => {
        if (copySelectedTableData.find(s => s.id === det.id)){          
          isSelectedCount++;
          (newSelectedRowsDetail[rowIndex] as Record<string, boolean>)[detIndex] = true;
        }
      });

      if (isSelectedCount === row.detail.length){
        (newSelectedRows as Record<string, boolean>)[rowIndex] = true;
      }
      
    });

    setRowSelectionPayments(newSelectedRows);
    setRowSelectionPaymentsDetails(newSelectedRowsDetail);
    setFilteredTableData(newFilteredTableData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalFilter]);

  useEffect(() => {
    dispatch(setDetalleNoRecaudado([]));
    dispatch(setAlert({alertText: "", alertVariant: undefined}));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dateValidator = (fechainicio?: string) => (fechafin?: string) =>{
    let val = false;

    if (fechafin && fechafin !== "" && fechainicio){
      val = Date.parse(fechafin.split("/").reverse().join()) < Date.parse(fechainicio.split("/").reverse().join())
    }        
    return val? ErrorValidations.EndDateGT : undefined;
  }

  async function getFilters() : Promise<string> {

    let fechaInicio = recaudacionPagoState.fechaInicio.length > 0 ? recaudacionPagoState.fechaInicio :  fechaCiclo.toLocaleDateString().replaceAll("-","/");
    let fechaFin = recaudacionPagoState.fechaFin.length > 0 ? recaudacionPagoState.fechaFin : fechaCiclo.toLocaleDateString().replaceAll("-","/");

    dispatch(setStringValue({name:"fechaInicio", value: fechaInicio}));      
    dispatch(setStringValue({name:"fechaFin", value: fechaFin}));

    const medioPago = splitValue(recaudacionPagoState.medioPago ?? "");    

    let filter = recaudacionPagoState.rut ? `&customerId=${recaudacionPagoState.rut}`: "";
    filter += recaudacionPagoState.entidadRecaudadora ? `&companyType=${recaudacionPagoState.entidadRecaudadora}`: "";
    filter += recaudacionPagoState.medioPago !== "0" ? `&paymentType=${medioPago[0]}`: "";
    if (1 in medioPago) {
      filter += recaudacionPagoState.medioPago ? `&tokuPaymentType=${medioPago[1]}`: "";
    }
    filter += recaudacionPagoState.usuarioCreador ? `&userCreator=${recaudacionPagoState.usuarioCreador.toLowerCase()}`: "&userCreator=0";
    filter += `&dateFrom=${getApiDateFormat(fechaInicio)}`;
    filter += `&dateTo=${getApiDateFormat(fechaFin)}`;
    
    return filter;
  }

  function getGroupedTable(result: PaymentModel[]):Array<GroupedPaymentModel>  {    
    let data = new Array<GroupedPaymentModel> ();

    if (!result || result?.length < 1){
      return [];
    }
    
    let rowId = 0;
    result.forEach((payment, index) => {
      let totalAmount = 0;
      
      //saltar sin collectionId
      if (payment.collectionId === undefined || payment.collectionId?.length === 0){
        return[];
      }
      
      //criterios de agrupación
      let groupedPay = data.find(pay =>
        pay.companyType === payment.company &&
        pay.paymentType === payment.paymentType &&
        pay.currencyType === payment.currencyType &&
        pay.paymentDate === getDateFromTimestamp(payment.paymentCreationDate!)
        );

      if (groupedPay){        
        groupedPay.paymentsQuantity++;
        totalAmount = groupedPay.total + payment.amount;
        groupedPay.total = totalAmount;

        groupedPay.detail.push({
          id: payment.id!,
          collectionId: payment.collectionId!,
          customerId: payment.customerId!,
          payerId: payment.payerId!,
          currencyType: payment.currencyType!,
          amount: payment.amount,
          index: index,
          rowId: groupedPay.id,
          detailRowId: groupedPay.detail.length
        });
      } else {        
        totalAmount = payment.amount;
        data.push({
          id: rowId,
          collectionId: payment.collectionId!,
          paymentType: payment.paymentType!,
          companyType: payment.company!,
          paymentsQuantity: 1,
          currencyType: payment.currencyType!,
          total: totalAmount,
          depositBank: payment.depositBank!,
          depositId: payment.depositId!,
          paymentDate: getDateFromTimestamp(payment.paymentCreationDate!),
          detail: [{
            id: payment.id!,
            collectionId: payment.collectionId!,
            customerId: payment.customerId!,
            payerId: payment.payerId!,
            currencyType: payment.currencyType!,
            amount: payment.amount,
            index: index,
            rowId: rowId,
            detailRowId: 0
          }],          
        });
        rowId++;
      }
      
    });    
    return data;
  }

  async function consultaAPI() {
    setIsLoadingTable(true);
    let filters = await getFilters();

    let resultInicial = await getPaymentList(`page=1&size=1&status=3` + filters,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

    if (!resultInicial || typeof(resultInicial) === "string" || !resultInicial.result || resultInicial.result.length === 0){
      setTableData([]);
      
      dispatch(setAlert({
        alertText:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados.",
        alertVariant:"error",
      }));
      setIsLoadingTable(false);
      return;
    }

    let finalResult:PaymentModel[] = [];

    for (let page = 1 ; page < ((resultInicial.paging.total / 500) + 1); page ++){
      let params = `page=${page}&size=500&status=3` + filters;
      let result = await getPaymentList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

      if (!result || typeof(result) === "string" || !result.result || result.result.length === 0){
        setTableData([]);
        
        dispatch(setAlert({
          alertText:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados.",
          alertVariant:"error",
        }));
        setIsLoadingTable(false);
        return;
      }

      finalResult.push(...result.result);
    }

    let groupedTable = getGroupedTable(finalResult);
    if(groupedTable.length===0){
      dispatch(setAlert({
        alertText:"No se han encontrado pagos con las especificaciones entregadas, verifique los datos ingresados.",
        alertVariant:"error",
      }));
      setIsLoadingTable(false);
      return
    }

    setTableData(groupedTable);
    setSelectedTableData([]);
    dispatch(setResumeBox({paymentsQuantity: 0, pagosCLP: 0, pagosUSD: 0}));    
    setIsLoadingTable(false);
  }

  async function handleClickGenerarConsulta(event: React.MouseEvent<HTMLButtonElement, MouseEvent>){
    let error = false;

    //validaciones
    if (error){      
      return;
    }
    
    await consultaAPI();
  }

  function onClickHandler(evt: React.MouseEvent<HTMLInputElement, MouseEvent>, tipo: string) {
    switch(tipo){
      case "fechaInicio":
        dispatch(setBooleanValue({name: "calendarHiddenInicio", value: !recaudacionPagoState.calendarHiddenInicio }));
        dispatch(setBooleanValue({name: "calendarHiddenFin", value: true }));
        dispatch(setStringValue({name: "errorFechaInicio", value: evt.currentTarget.value ? "" : recaudacionPagoState.errorFechaInicio }));
        break;
      case "fechaFin":
        dispatch(setBooleanValue({name: "calendarHiddenFin", value: !recaudacionPagoState.calendarHiddenFin }));
        dispatch(setBooleanValue({name: "calendarHiddenInicio", value: true }));
        dispatch(setStringValue({name: "errorFechaFin", value: evt.currentTarget.value ? "" : recaudacionPagoState.errorFechaFin }));
        break;
    }
  }

  function onClickDayHandler(evt: Date, tipo: string) {
    switch(tipo){
      case "fechaInicio":
        dispatch(setStringValue({name: "fechaInicio", value: evt.toLocaleDateString().replaceAll("-","/") }));
        dispatch(setBooleanValue({name: "calendarHiddenInicio", value: true }));
        dispatch(setStringValue({name: "errorFechaInicio", value: evt ? "" : recaudacionPagoState.errorFechaInicio }));
        break;
      case "fechaFin":
        dispatch(setStringValue({name: "fechaFin", value: evt.toLocaleDateString().replaceAll("-","/") }));
        dispatch(setBooleanValue({name: "calendarHiddenFin", value: true }));        
        dispatch(setStringValue({name: "errorFechaFin", value: evt ? "" : recaudacionPagoState.errorFechaFin }));
        break;
    }
  }

  function onMouseOverHandler(tipo: string) {
    switch(tipo){
      case "fechaInicio":
        dispatch(setBooleanValue({name: "calendarHiddenInicio", value: true }));
        break;
      case "fechaFin":
        dispatch(setBooleanValue({name: "calendarHiddenFin", value: true }));
        break;
    }
  }

    async function descargarDetalleXLSX(event: React.MouseEvent<HTMLButtonElement, MouseEvent>){
      let filters = await getFilters();
      let resultInicial = await getPaymentList(`page=1&size=1&status=3` + filters,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);
  
      if (!resultInicial || typeof(resultInicial) === "string" || !resultInicial.result || resultInicial.result.length === 0){
        setTableData([]);
        
        dispatch(setAlert({
          alertText:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados.",
          alertVariant:"error",
        }));
         
        return;
      }

      let finalResult:PaymentModel[] = [];

      for (let page = 1 ; page < ((resultInicial.paging.total / 500) + 1); page ++){
        let params = `page=${page}&size=500&status=3` + filters;
        let result = await getPaymentList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

      if (!result || typeof(result) === "string" || !result.result || result.result.length === 0){
        setTableData([]);
        
        dispatch(setAlert({
          alertText:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados.",
          alertVariant:"error",
        }));
        
        return;
      }

      finalResult.push(...result.result);
    }
    
    let data = finalResult.filter(r => r.collectionId && r.collectionId.length>0)
 
    const titulo = [["Reporte de Recaudación de Pagos"]];

    const workSheet=XLSX.utils.json_to_sheet(data.map((p) => {
      return ({
        'RUT cliente': p.customerId,
        'RUT pagador':p.payerId,
        'Fecha de pago': p.paymentCreationDate,
        'Fecha devengo': p.accrualDate,
        'Monto': p.amount,
        'Moneda': p.currencyType,
        'Fecha recaudación': p.paymentConfirmDate,
        'Estado': p.status,
        'Medio de pago': p.paymentType,
        'Compañia Recaudadora': p.company,
        'Banco recaudador': p.depositBank,
        'Usuario Creador': p.userCreator,
        'ID Cobranza': p.collectionId
      })
    }),{origin: 'A2', cellStyles:true});

    const workBook=XLSX.utils.book_new()
  
    XLSX.utils.sheet_add_aoa(workSheet,titulo, { origin: 'A1' });

    XLSX.utils.book_append_sheet(workBook,workSheet,"Recaudar Pagos")
  
    //Binary string
    XLSX.write(workBook,{bookType:"xlsx",type:"binary"})
    //Download
    XLSX.writeFile(workBook,"Recaudar Pagos.xlsx")
  }

  async function descargarDetalleCSV(event: React.MouseEvent<HTMLButtonElement, MouseEvent>){
    
    let filters = await getFilters();
    let resultInicial = await getPaymentList(`page=1&size=1&status=3` + filters,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);
  
      if (!resultInicial || typeof(resultInicial) === "string" || !resultInicial.result || resultInicial.result.length === 0){
        setTableData([]);
        
        dispatch(setAlert({
          alertText:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados.",
          alertVariant:"error",
        }));
         
        return;
      }
  
      let finalResult:PaymentModel[] = [];

      for (let page = 1 ; page < ((resultInicial.paging.total / 500) + 1); page ++){
        let params = `page=${page}&size=500&status=3` + filters;
        let result = await getPaymentList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

        if (!result || typeof(result) === "string" || !result.result || result.result.length === 0){
          setTableData([]);
          
          dispatch(setAlert({
            alertText:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados.",
            alertVariant:"error",
          }));
          
          return;
        }

        finalResult.push(...result.result);
      }

      let data = finalResult.filter(r => r.collectionId && r.collectionId.length>0)
  
      const workSheet=XLSX.utils.json_to_sheet(data.map((p) => {
        return ({
          'RUT cliente': p.customerId,
          'RUT pagador':p.payerId,
          'Fecha de pago': p.paymentCreationDate,
          'Fecha devengo': p.accrualDate,
          'Monto': p.amount,
          'Moneda': p.currencyType,
          'Fecha recaudación': p.paymentConfirmDate,
          'Estado': p.status,
          'Medio de pago': p.paymentType,
          'Compañia Recaudadora': p.company,
          'Banco recaudador': p.depositBank,
          'Usuario Creador': p.userCreator,
          'ID Cobranza': p.collectionId
        })
      }),{origin: 'A2', cellStyles:true});
    const workBook=XLSX.utils.book_new()

    const titulo = [["Reporte de Recaudación de Pagos"]];

    XLSX.utils.book_append_sheet(workBook,workSheet,"Recaudar Pagos")

    XLSX.utils.sheet_add_aoa(workSheet,titulo, { origin: 'A1' });

    //Binary string
    XLSX.write(workBook,{bookType:"csv",type:"binary"})
    //Download
    XLSX.writeFile(workBook,"Recaudar Pagos.csv")
  }

  async function recaudarPagos(){
    if (recaudacionPagoState.paymentsIds.length < 1){
      dispatch(setAlert({
        alertVariant:"error",
        alertText:"Ha ocurrido un error con un pago a recaudar."
      }));
      return;
    }

    let apiAnwswer = undefined;
    apiAnwswer = await paymentUpdateStatus({paymentIds: recaudacionPagoState.paymentsIds, newStatus: 4},userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);      

    if (typeof(apiAnwswer) === "string"){
      dispatch(setBooleanValue({ name: "showTableDetalleNoRecaudado", value: false}));
      dispatch(setDetalleNoRecaudado([]));
      dispatch(setAlert({
        alertVariant: "error",
        alertText: apiAnwswer
      }));
    } else {
      if (apiAnwswer.length > 0){
        let newDetalleNoRecaudado:Array<PaymentModelDetail> = [];

        apiAnwswer.forEach((pay) => {
          let dpc = selectedTableData.find((d) => d.id === pay);
          if (dpc){
            newDetalleNoRecaudado.push(dpc);
          }
        })
        
        dispatch(setBooleanValue({ name: "showTableDetalleNoRecaudado", value: false}));
        dispatch(setDetalleNoRecaudado(newDetalleNoRecaudado));
        
        dispatch(setAlert({
          alertVariant: "warning",
          alertText: apiAnwswer.length === 1 ? "El siguiente pago no fue recaudado: ": "Los siguientes pago no fueron confirmados: "
        }));
      } else {
        dispatch(setBooleanValue({ name: "showTableDetalleNoRecaudado", value: false}));
        dispatch(setDetalleNoRecaudado([]));
        dispatch(setAlert({
          alertVariant: "success",
          alertText: "Pago(s) recaudado(s) exitosamente."
        }));
      }
  
      dispatch(setResumeBox({paymentsQuantity: 0, pagosCLP: 0, pagosUSD: 0}))
      setSelectedTableData([]);
      setTableData([]);
      
      await consultaAPI();
    }
  }

  function rutChangeHandler( evt: React.ChangeEvent<HTMLInputElement>){
    let newRut = evt.currentTarget.value.toUpperCase();
    let oldRut = recaudacionPagoState.rut ?? newRut.substring(0,newRut.length-1);
    const regexp = /^[0-9K-]+$/;
    if (
      (newRut && !regexp.test(newRut)) ||
      (newRut.startsWith("0") || newRut.startsWith("K")) ||
      (newRut.includes("-") && newRut.split("-").length > 1 && newRut.split("-")[1].length > 1) ||
      (newRut.includes("-") && newRut.lastIndexOf("-") !== newRut.indexOf("-")) ||
      (newRut.includes("K") && newRut.lastIndexOf("K") !== newRut.indexOf("K"))
    ){
      evt.currentTarget.value = oldRut;
    } else {
      dispatch(setStringValue({ name: "rut", value: newRut}))
    }
  }

  const groupedPaymentTable = useMaterialReactTable({
    columns: useMemo(() => columnsGroupedPaymentsCollection,[]),
    data: filteredTableData ?? [],
    localization: {
      showHideSearch: "mostrar / ocultar búsqueda",
      search:"Búsqueda",
      sortByColumnAsc:"Ordernar por {column} ascendente",
      sortByColumnDesc:"Ordernar por {column} descendente",
      sortedByColumnAsc: 'Ordernado por {column} ascendente',
      sortedByColumnDesc: 'Ordernado por {column} descendente',
      selectedCountOfRowCountRowsSelected: '',
      select: 'Selección'
    },
    muiTablePaperProps:{
      style:{
        boxShadow:"none",
        height:"auto"
      },      
    },
    muiBottomToolbarProps:{
      style:{
        marginBottom:"25px",
      }
    },    
    enablePagination: false,
    enableColumnActions: false,
    enableDensityToggle:false,
    enableFullScreenToggle: false,
    enableHiding: false,
    enableFilters: true,
    enableColumnFilters: false,
    enableRowSelection: true,
    enableMultiRowSelection: true,
    enableSelectAll: false,
    enableStickyHeader: true,
    enableGlobalFilter: true,
    enableExpandAll: true,
    onRowSelectionChange: (updater) => {      
      setRowSelectionPayments(updater);
      if (updater instanceof Function){
        let oldState = Object.keys(cloneDeep(rowSelectionPayments));
        let newState = Object.keys(updater(rowSelectionPayments));
        let newSelectedRows = newState.filter(s => !oldState.includes(s));
        let newUnselectedRows = oldState.filter(s => !newState.includes(s));
        
        let newFilteredTableData = cloneDeep(filteredTableData);
        let newRowSelectionPaymentsDetails = cloneDeep(rowSelectionPaymentsDetails);
        let newSelectedTableData = cloneDeep(selectedTableData);
        
        newSelectedRows.forEach(r => {
          newFilteredTableData[parseInt(r)].detail.forEach((d, index) => {            
            (newRowSelectionPaymentsDetails[parseInt(r)] as Record<string, boolean>)[index] = true;
            if (!newSelectedTableData.find(s=> s.id === d.id)){
              newSelectedTableData.push(d);
            }
          })
        })

        newUnselectedRows.forEach(r => {          
          (newRowSelectionPaymentsDetails[parseInt(r)] as Record<string, boolean>) = {};
          newFilteredTableData[parseInt(r)].detail.forEach(d =>{
            let element = newSelectedTableData.find(s=> s.id === d.id);
            if (element){
              newSelectedTableData.splice(newSelectedTableData.indexOf(element),1);
            }
          });
        });        

        setFilteredTableData(newFilteredTableData);
        setSelectedTableData(newSelectedTableData);
        setRowSelectionPaymentsDetails(newRowSelectionPaymentsDetails);
      };
      
    },    
    onGlobalFilterChange: setGlobalFilter,
    state:{ rowSelection: rowSelectionPayments, isLoading: isLoadingTable},
    muiDetailPanelProps: () => ({
      sx: (theme) => ({
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255,255,255,0.1)'
            : 'rgba(200,200,200,0.1)',
      }),
    }),
    muiExpandButtonProps: ({ row }) => ({
      sx: {
        transform: row.getIsExpanded() ? 'rotate(180deg)' : 'rotate(-90deg)',
        transition: 'transform 0.2s',
      },
    }),       
    renderDetailPanel: ({row}) => 
      row.original.detail ? (
        <MaterialReactTable table={          
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useMaterialReactTable({
            // eslint-disable-next-line react-hooks/rules-of-hooks
            columns: useMemo(() => columnsGroupedPaymentsDetail,[]),
            data: row.original.detail ?? [],
            enablePagination: false,
            enableColumnActions: false,
            enableDensityToggle:false,
            enableFullScreenToggle: false,
            enableHiding: false,
            enableFilters: false,
            enableColumnFilters: false,
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSelectAll: false,
            enableStickyHeader: true,
            enableBottomToolbar: false,
            enableTopToolbar: false,
            muiTablePaperProps:{
              style:{
                boxShadow:"none",          
                width:"60em",          
                margin:"-1em 0em -1em 7em",
              },
            },
            localization: {
              showHideSearch: "mostrar / ocultar búsqueda",
              search:"Búsqueda",
              sortByColumnAsc:"Ordernar por {column} ascendente",
              sortByColumnDesc:"Ordernar por {column} descendente",
              sortedByColumnAsc: 'Ordernado por {column} ascendente',
              sortedByColumnDesc: 'Ordernado por {column} descendente',
              selectedCountOfRowCountRowsSelected: '',
              select: 'Selección'
            },
            onRowSelectionChange: (updater) => {
              if (updater instanceof Function){                                
                let newRowDetailState = updater(rowSelectionPaymentsDetails[parseInt(row.id)]);
                let newRowSelectionPaymentDetails = cloneDeep(rowSelectionPaymentsDetails);
                let newRowDetailSelectionIndex = Object.keys(newRowDetailState)
                newRowSelectionPaymentDetails[parseInt(row.id)] = newRowDetailState;

                let newFilteredTableData = cloneDeep(filteredTableData);
                let newSelectedTableData = cloneDeep(selectedTableData);
                newFilteredTableData[parseInt(row.id)].detail.forEach((d, index)=>{
                  let selectedItem = newSelectedTableData.find(s => s.id === d.id);
                  let isSelected = newRowDetailSelectionIndex.includes(index.toString());
                  if (isSelected && selectedItem === undefined){
                    newSelectedTableData.push(d);
                  } else if (!isSelected && selectedItem){
                    newSelectedTableData.splice(newSelectedTableData.indexOf(selectedItem),1);
                  }
                });
                
                row.toggleSelected(newFilteredTableData[parseInt(row.id)].detail.length === newRowDetailSelectionIndex.length);

                setSelectedTableData(newSelectedTableData);
                setRowSelectionPaymentsDetails(newRowSelectionPaymentDetails);
              }
            },
            state:{ rowSelection: rowSelectionPaymentsDetails[parseInt(row.id)]},
          })

        }/>
      ) : null
  });

  function handleFilterclean(){
    dispatch(setInitialState());
    setTableData([]);
  }

  return(
    <div className={props.className}>
      <Title
        className={props.className + '-title'}
        text="Recaudación de pago"
      />
      <Card className="rp-filter">          
        <Card className="rp-filter-row">
        <InputTexto
            className="rp-filter-input"
            label="Filtrar por RUT del cliente"              
            value={recaudacionPagoState.rut}
            onChange={rutChangeHandler}              
            validators={[FormatRutValidator, RutValidator]}
            error={recaudacionPagoState.errorRut}
            alt="rut"
          />
        <InputSelect
            className="rp-filter-select"
            label="Filtrar por entidad recaudadora"
            value={recaudacionPagoState.entidadRecaudadora}
            values={EntidadRecaudadora}
            onChange={(evt) => dispatch(setNumberValue({name: "entidadRecaudadora", value: parseInt(evt.currentTarget.value)}))}
          />
          <InputSelect
            className="rp-filter-select"
            label="Filtrar por medio de pago"
            value={recaudacionPagoState.medioPago}
            values={paymentTypes}
            onChange={(evt) => dispatch(setStringValue({name: "medioPago", value: evt.currentTarget.value}))}
          />
        </Card>   
        <Card className="rp-filter-row">
          <InputSelect
            className="rp-filter-select"
            label="Filtrar por usuario creador"
            value={recaudacionPagoState.usuarioCreador}
            values={paymentUsers}
            onChange={(evt) => dispatch(setStringValue({name: "usuarioCreador", value: evt.currentTarget.value}))}
          />          
        <InputFecha
            className="rp-filter-fecha"
            label="Fecha de inicio"
            formatlabel="Usar el formato: DD/MM/AAAA"
            value={recaudacionPagoState.fechaInicio}              
            calendarhidden={recaudacionPagoState.calendarHiddenInicio}
            calendarmaxdate={fechaCiclo}            
            onClickDay={(e) => onClickDayHandler(e,"fechaInicio")}
            onClick={(e) => onClickHandler(e,"fechaInicio")}
            onMouseOver={() => onMouseOverHandler("fechaInicio")}
            validators={[RequiredValidator]}
            error={recaudacionPagoState.errorFechaInicio}              
          />
          <InputFecha
            className="rp-filter-fecha"
            label="Fecha de termino"
            formatlabel="Usar el formato: DD/MM/AAAA"
            value={recaudacionPagoState.fechaFin}
            calendarhidden={recaudacionPagoState.calendarHiddenFin}
            calendarmaxdate={fechaCiclo}            
            onClickDay={(e) => onClickDayHandler(e,"fechaFin")}
            onClick={(e) => onClickHandler(e,"fechaFin")}
            onMouseOver={() => onMouseOverHandler("fechaFin")}
            validators={[dateValidator(recaudacionPagoState.fechaInicio)]}
            error={recaudacionPagoState.errorFechaFin}
          />          
          
        </Card>
        <Card style={{
          display: "flex",
          flexDirection: "row",
          width: "1392px",
          alignItems: "flex-end",
          gap: "24px"
        }}>            
          <Button
            style={{
              display: "flex",
              height: "48px",
              padding: "12px 32px",
              justifyContent: "center",
              alignItems: "center",
              gap: "4px",
              borderRadius: "25px",
              border: "1px solid #0061A0",
              background:"#FFFFFF",
              color: "#0061A0",
              textAlign: "center",
              fontFeatureSettings: "'clig' off, 'liga' off",
              fontFamily: "FS Elliot Pro Bold",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "21px"
            }}  
            text="Generar Consulta"
            onClick={handleClickGenerarConsulta}
          />
          <Button
            style={{
              display: "flex",
              height: "48px",
              padding: "10px 32px",
              justifyContent: "center",
              alignItems: "center",
              gap: "4px",
              borderRadius: "100px",
              border: "1px solid rgba(51, 51, 51, 0.00)",
              background: "rgba(51, 51, 51, 0.00)",
              color: "#0061A0",
              fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
              fontFamily: "FS Elliot Pro Bold",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "28px"
            }}  
            text="Limpiar filtros"
            onClick={handleFilterclean}
          />
        </Card>
      </Card>
      {recaudacionPagoState.alertText &&
        <Alert          
          text={recaudacionPagoState.alertText}
          type={recaudacionPagoState.alertVariant}
          onClose={() => {
            dispatch(setAlert({alertText:"", alertVariant: undefined}));
            dispatch(setBooleanValue({ name:"showTableDetalleNoRecaudado", value: false }));
        }}
        >
          { recaudacionPagoState.detalleNoRecaudado.length > 0 ?
            <Button
              text="Ver detalle"
              style={PrimaryButtonStyle}
              onClick={() => {
                dispatch(setBooleanValue({
                  name:"showTableDetalleNoRecaudado",
                  value: !recaudacionPagoState.showTableDetalleNoRecaudado
                }))
              }}
            /> : undefined}
          </Alert>
      }
      {recaudacionPagoState.alertText && recaudacionPagoState.showTableDetalleNoRecaudado &&
          recaudacionPagoState.detalleNoRecaudado.map((dnc, index) => 
            <div key={'d'+index} style={DetalleNoConfirmadoStyle}>
              Rut cliente: {dnc.customerId} Rut pagador: {dnc.payerId} Moneda: {dnc.currencyType} Monto: {dnc.amount}              
            </div>
          )
        } 
      <Card
        style={SummaryTableStyle}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "24px"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flexStart",
              gap: "8px",
              color: "#333333"
            }}
          >
            <span style={SummaryAmountStyle}>
              Pagos a recaudar: {recaudacionPagoState.paymentsQuantity}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flexStart",
              gap: "8px",
              color: "#333333"
            }}
          >
            <span style={SummaryAmountStyle}>
              Pagos en CLP: {moneyFormat(recaudacionPagoState.pagosCLP,"CLP")}
            </span>              
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flexStart",
              gap: "8px",
              color: "#333333"
            }}
          >
            <span style={SummaryAmountStyle}>
              Pagos en USD: {moneyFormat(recaudacionPagoState.pagosUSD,"USD")}
            </span>
          </div>
        </div>
        <Button
          style={{
            ...SecondaryButtonStyle,
            width:"20em"
          }}
          text="Recaudar Pago"
          onClick={() => {
            let paymentsIds:Array<string> = [];
            selectedTableData.forEach(row =>{
              paymentsIds.push(row.id);
            });
            dispatch(setPaymentsIds({paymentsIds: paymentsIds}));
            if (recaudacionPagoState.paymentsQuantity > 0) {
              setModalIsOpen(true);
            }
          }}
        />
      </Card>
      <div className="result">
        <div className="result-title">
          <Button
            className="result-title-download-button"
            text="Descargar detalle XLSX"              
            hidden={tableData === undefined || tableData.length < 1}
            onClick={descargarDetalleXLSX}
          >
            <LuDownload/>
          </Button>
          <Button
            className="result-title-download-button"
            text="Descargar detalle CSV"              
            hidden={tableData === undefined || tableData.length < 1}
            onClick={descargarDetalleCSV}
          >
            <LuDownload/>
          </Button>
        </div>
        {((tableData && tableData.length > 0) || isLoadingTable) &&
          <MaterialReactTable table={groupedPaymentTable}/>
        }
      </div>
        <Modal
          isOpen={modalIsOpen}
          hasCloseBtn={true}
          onClose={() => setModalIsOpen(false)}
          children={
            <ModalConfirm
              payments={selectedTableData}
              title="Está seguro que desea recaudar los siguientes pagos:"
              confirmButtonText="Recaudar"
              handleConfirm={() => {
                setModalIsOpen(false);
                recaudarPagos();
              }}
              handleCloseModal={() => setModalIsOpen(false)}
            />
          }
        />
    </div>
    
  )
}

export default RecaudacionPago;